import domReady from '@wordpress/dom-ready';
import flatpickr from 'flatpickr/dist/flatpickr.min.js';

domReady(() => {
  window.locale = $('html').attr('lang');

  if (window.locale === 'fr-CA') {
    flatpickr.localize(require(`flatpickr/dist/l10n/fr.js`));
  }

  const FWP = window.FWP;
  const FWP_JSON = window.FWP_JSON;
  // Better always use a two digit format in your dates obj
  function twoDigitsDateFormat(val) {
    return ('0' + val).slice(-2);
  }

  FWP.logic = FWP.logic || {};

  /* ======== Support duplicate facets ======== */

  jQuery('.facetwp-facet').each(function () {
    // jQuery doesn't support useCapture, so add the event listeners manually
    // useCapture handles outer elements first (unlike event bubbling)
    this.addEventListener(
      'click',
      function () {
        const $items = jQuery('.facetwp-facet-' + jQuery(this).data('name'));
        if (1 < $items.length) {
          $items.addClass('facetwp-ignore');
          jQuery(this).removeClass('facetwp-ignore');
        }
        FWP.last_active_facet = jQuery(this);
      },
      true
    );
  });

  FWP.hooks.addAction('facetwp/refresh/date_picker', ($this, facetName) => {
    const min = $this.find('.facetwp-date-min').val() || '';
    const max = $this.find('.facetwp-date-max').val() || '';
    FWP.facets[facetName] = '' !== min || '' !== max ? [min, max] : [];
  });

  FWP.hooks.addFilter(
    'facetwp/selections/date_picker',
    function (output, params) {
      const vals = params.selected_values;
      const $el = params.el;
      let out = '';

      if ('' !== vals[0]) {
        out +=
          ' ' +
          FWP_JSON.datepicker.fromText +
          ' ' +
          $el.find('.facetwp-date-min').next().val();
      }
      if ('' !== vals[1]) {
        out +=
          ' ' +
          FWP_JSON.datepicker.toText +
          ' ' +
          $el.find('.facetwp-date-max').next().val();
      }
      return out;
    }
  );

  jQuery(document).on('facetwp-loaded', () => {
    const $dates = jQuery(
      '.facetwp-type-date_picker .facetwp-date:not(".ready, .flatpickr-alt")'
    );
    if (0 === $dates.length) {
      return;
    }

    const defaults = {
      dateFormat: 'Ymd',
      altInput: true,
      altInputClass: 'flatpickr-alt',
      altFormat: 'Ymd',
      disableMobile: true,
      locale: FWP_JSON.datepicker.locale,
      static: true,
      monthSelectorType: 'static',
      nextArrow: "<i class='icon icon-arrow_long_right'></i>",
      prevArrow: "<i class='icon icon-arrow_long_right'></i>",
      inline: true,
      onChange: () => {
        FWP.autoload();
      },
    };

    $dates.each(function () {
      const $this = jQuery(this);
      const facetName = $this.closest('.facetwp-facet').attr('data-name');
      const settings = FWP.settings[facetName];
      const flatpickrOpts = defaults;

      flatpickrOpts.dateFormat = settings.format;
      flatpickrOpts.altFormat = settings.format;
      flatpickrOpts.static = settings.static || true;

      /* adding dots to days with events */
      flatpickrOpts.onDayCreate = function (dObj, dStr, fp, dayElem) {
        const currentDate =
          dayElem.dateObj.getFullYear() +
          twoDigitsDateFormat(dayElem.dateObj.getMonth() + 1) +
          twoDigitsDateFormat(dayElem.dateObj.getDate());
        const value = settings.busy_days[currentDate] || false;
        if (value) {
          dayElem.innerHTML += `<span class='icon-point-calendar'></span>`;
        }
      };

      const opts = FWP.hooks.applyFilters(
        'facetwp/set_options/date_picker',
        flatpickrOpts,
        {
          facet_name: facetName,
          element: $this,
        }
      );
      new flatpickr(this, opts);
      $this.addClass('ready');
    });
  });
});
